module.exports = __webpack_public_path__ + "media/images/CHA-07-e94f4a730708d8a5309ca533a9ad8879.jpg";